import Mediabox from '#components/common/mediabox/Mediabox';
import {
  getMediabox,
  imageRatioPerComponent,
  ImageRendererTypes,
} from '#config';
import React, { FC } from 'react';
import {
  AllowedImageAspectRatios,
  Media,
  Teaser,
} from '#types/generated/graphql-types';
import {
  NamedToNumericRatio,
  NumericToNamedRatio,
} from '#utils/image-ratio-map';

type Props = {
  data: Media | Teaser;
  imageRenderer?: ImageRendererTypes;
  aspectRatio?: AllowedImageAspectRatios;
};

const MediaboxHOC: FC<Props> = ({ data, imageRenderer, aspectRatio }) => {
  if (!data) return null;

  let numericRatio; //i.e. 4_3
  if (typeof imageRenderer !== 'undefined') {
    numericRatio = imageRatioPerComponent[imageRenderer].primary;
  }
  if (typeof aspectRatio !== 'undefined') {
    numericRatio = NamedToNumericRatio[aspectRatio];
  }

  if (typeof data['teaserImageFormats'] !== 'undefined') {
    const namedRatio = NumericToNamedRatio[numericRatio];
    const image = data['teaserImageFormats'][namedRatio];
    return <img src={image?.medium} alt={data?.title} />;
  } else if (typeof data['teaserImages'] !== 'undefined') {
    const image = data['teaserImages'].find(
      (img) => img.aspectRatio === numericRatio
    );

    return <img src={image?.medium} alt={data?.title} />;
  } else {
    /** TODO fix this array accessor stuff and add proper types!*/
    return <Mediabox {...getMediabox(imageRenderer, data['teaserImage'])} />;
  }
};

export default MediaboxHOC;
